export const emailTemplateQueryKeys = {
  _base: () => ["emailTemplates"],
  all: () => [...emailTemplateQueryKeys._base()],
  single: (emailTemplateId: string) => [...emailTemplateQueryKeys._base(), emailTemplateId],
};
